import React from 'react';
import loadable from '@loadable/component';
import styles from './SimilarProductsSection.module.scss';
import PageSectionHeader from '../PageSectionHeader';
import { useSliderScroll } from '../Sliders/useSliderScroll';
import { VIEW_OPTIONS_TILES } from '../SearchResultsPage/SRP.definitions';
import getCDNImage from '../../utils/getCDNImage';
import { SLIDER_CUSTOM_NAV } from '../Sliders/Sliders.def';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { PRODUCT_SIMILAR_PRODUCTS_SECTION } from '../Product/ProductCardOriginType.def';
import { useNavigate } from 'react-router-dom';

const Sliders = loadable(() => import('Components/Sliders/Sliders'));
const Product = loadable(() => import('../Product/Product'));

const defaultTitle = (
  <>
    <FormattedMessage default="Related" id="common.related_products_1" />{' '}
    <b>
      <FormattedMessage default="products" id="common.related_products_2" />
    </b>
  </>
);

//initially integrated into PDP and PDPMP
const SimilarProductsSection = ({ products, classList, title = defaultTitle }) => {
  const {
    onScrollForward,
    onScrollBack,
    scrollLeft,
    isScrolledToEnd,
    sliderContainerRef,
    onScroll,
  } = useSliderScroll();
  const navigate = useNavigate();

  if (!products?.length) return null;

  return (
    <section className={classList?.root || styles.root}>
      <PageSectionHeader
        classList={{ title: classList?.title, root: styles.sectionHeader }}
        withSliderControls
        sliderNext={onScrollForward}
        sliderPrevious={onScrollBack}
      >
        {title}
      </PageSectionHeader>
      <div className={classNames('container', styles.noSidePadding)}>
        <Sliders
          classList={{ root: styles.slidersRoot, slides: styles.slidesWrapper, card: styles.productCardWrapper }}
          testId="newproductsslider"
          type={SLIDER_CUSTOM_NAV}
          scrollLeft={scrollLeft}
          isScrolledToEnd={isScrolledToEnd}
          sliderContainerRef={sliderContainerRef}
          viewAll={false}
          onScroll={onScroll}
        >
          {products.map((product, index) => (
            <Product
              discountPercent={product?.discount_pct}
              adult={product?.adult}
              key={`newproductcard${product.id}`}
              brand={product?.brand}
              classList={{ root: styles.productCard }}
              currency={product?.currency || process.env.REACT_APP_WEBSITE_CURRENCY}
              shortDesc={product?.shortDesc}
              EAN={product?.offers?.[0]?.EAN}
              price={product.price}
              originalPrice={product.price_original || product.price}
              id={product.id}
              image={getCDNImage(product?.thumbs?.[0])}
              isSelected={false}
              name={product.name}
              onClick={() => navigate(product.pdp_path)}
              shop={{ name: product.campaign }}
              SKU={product.SKU}
              showProductLink={false}
              url={product.pdp_path}
              view={VIEW_OPTIONS_TILES}
              status={product.new}
              shopId={product?.shop_id}
              merchantPid={product?.merchant_product_id}
              resultRank={index}
              category={product?.category}
              productCardOriginType={PRODUCT_SIMILAR_PRODUCTS_SECTION}
            />
          ))}
        </Sliders>
      </div>
    </section>
  );
};

export default SimilarProductsSection;
